<template>
  <Modal :is-open="isOpen" container-class="rounded-lg" ref="modal" :showCloseButton="false">
    <div class="flex flex-col items-center px-4 py-3 text-left">
      <div class="flex flex-col items-start space-y-2">
        <MessageCard
          message="Avance con esta acción si y sólo si ha recibido la confirmación de la revocatoria por parte de Migraciones en su casilla de correos (verificar casilla de Spam).
Si realiza la confirmación, se deshabilitará la opción de reenviar."
          type="info"
        />
      </div>
    </div>
    <h2 class="text-center text-lg font-bold">
      ¿Está seguro que desea confirmar la recepción de la notificación?
    </h2>

    <template #footer>
      <div class="m-2 flex flex-row justify-center space-x-4">
        <button
          class="btn btn-primary inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
          @click="$emit('modal:close')"
          :disabled="isSendingVerificacion"
        >
          Cancelar
        </button>

        <button
          class="btn btn-primary inline-flex items-center rounded-md border border-colescba-blue-300 bg-colescba-blue-600 px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out hover:bg-colescba-blue-500 focus:outline-none focus:ring focus:ring-colescba-blue-300 focus:ring-opacity-50"
          @click="confirm"
          :disabled="isSendingVerificacion"
        >
          <span v-if="!isSendingVerificacion">
            <p>Confirmar</p>
          </span>
          <span v-else class="flex flex-row space-x-2">
            <LoadingCircle class="h-7 w-7" />
            <p>Verificando notificación...</p>
          </span>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useComposeModal } from '@colescba/ui'
import { useService } from '@colescba/app-vue'
import MessageCard from '../Core/MessageCard.vue'

export default {
  name: 'VerificarNotificacion',
  components: { MessageCard },
  props: {
    solicitudId: { type: Number, required: true },
    onConfirm: { type: Function, required: true },
  },
  mixins: [useComposeModal(), useService('api')],
  data() {
    return {
      isSendingVerificacion: false,
    }
  },
  methods: {
    async confirm() {
      this.isSendingVerificacion = true
      await this.api.solicitudes.notificacionVerificada(this.solicitudId)
      this.isSendingNotificaisSendingVerificacioncion = false
      this.onConfirm()
      this.$emit('modal:close')
    },
  },
}
</script>
